import { CardPosition } from "../utils/resizeCard";

export default class DragHandler {
  posX: number;
  posY: number;

  defaultMargin = 20;
  stickMargin = 30;

  stickMarginRight = -1;
  stickMarginBottom = -1;

  offsetTop: number;
  offsetLeft: number;

  neverMoved = true;

  constructor(
    // the component on which to click for dragging
    private dragTarget: HTMLElement,
    // the component that is moved on dragging
    private dragContent: HTMLElement,
    private position: CardPosition
  ) {
    this.offsetTop = this.dragContent.offsetTop;
    this.offsetLeft = this.dragContent.offsetLeft;
  }

  enableDragging() {
    this.dragTarget.style.cursor = "move";
    this.dragTarget.addEventListener("mousedown", this.dragMouseDown.bind(this));

    this.updateStickMargins();

    window.addEventListener("resize", this.updatePositionOnResize.bind(this));
  }

  dragMouseDown(e: MouseEvent) {
    e.preventDefault();

    this.neverMoved && (this.neverMoved = false);
    this.posX = e.clientX;
    this.posY = e.clientY;
    document.onmouseup = this.closeDragElement.bind(this);
    document.onmousemove = this.elementDrag.bind(this);
  }

  elementDrag(e: MouseEvent) {
    e.preventDefault();

    // calculate the new position:
    const offsetX = this.posX - e.clientX;
    const offsetY = this.posY - e.clientY;
    this.posX = e.clientX;
    this.posY = e.clientY;
    // update position
    const el = this.dragContent;

    let newTop = el.offsetTop - offsetY;
    newTop = Math.max(newTop, 0);
    newTop = Math.min(newTop, window.innerHeight - el.offsetHeight);
    newTop = Math.max(newTop, 0);

    let newLeft = el.offsetLeft - offsetX;
    newLeft = Math.max(newLeft, 0);
    newLeft = Math.min(newLeft, window.innerWidth - el.offsetWidth);
    newLeft = Math.max(newLeft, 0);

    this.position.yTop = newTop + "px";
    this.position.xLeft = newLeft + "px";
    this.position.yBottom = "unset";

    this.updateStickMargins();
  }

  updateStickMargins() {
    this.stickMarginRight = this.rightMargin() < this.stickMargin ? this.rightMargin() : -1;
    this.stickMarginBottom = this.bottomMargin() < this.stickMargin ? this.bottomMargin() : -1;
  }

  rightMargin() {
    const el = this.dragContent;
    return window.innerWidth - el.offsetLeft - el.offsetWidth;
  }

  bottomMargin() {
    const el = this.dragContent;
    return window.innerHeight - el.offsetTop - el.offsetHeight;
  }

  closeDragElement() {
    /* stop moving when mouse button is released:*/
    document.onmouseup = null;
    document.onmousemove = null;
  }

  updatePositionOnResize() {
    if (!this.neverMoved) {
      const el = this.dragContent;
      if (this.bottomMargin() <= this.defaultMargin) {
        this.position.yTop = Math.max(window.innerHeight - el.offsetHeight - this.defaultMargin, 0) + "px";
      }
      if (this.rightMargin() <= this.defaultMargin) {
        this.position.xLeft = Math.max(window.innerWidth - el.offsetWidth - this.defaultMargin, 0) + "px";
      }
      if (this.stickMarginRight >= 0) {
        this.position.xLeft = window.innerWidth - el.offsetWidth - this.stickMarginRight + "px";
      }
      if (this.stickMarginBottom >= 0) {
        this.position.yTop = window.innerHeight - el.offsetHeight - this.stickMarginBottom + "px";
      }
    }
  }
}
